
import React, { Fragment, useState } from 'react';
import { Button, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import { clearLocalStorageExceptOne } from '../../../common/Utilities';
const ThankYouModal = ({ open ,close }) => {
    const navigate = useNavigate();

    return (
        open == true &&
        <div
            className="fixed inset-0 z-50 flex items-center justify-center backdrop-filter backdrop-blur-sm"
            style={{ background: 'rgba(0, 0, 0, 0.5)' }}
        >
            <Modal
                centered
                onCancel={close}
                open={open}
                footer={false}
            >
                <div className='flex m-[0_auto] justify-center'>
                    <img src='/images/final_tick.png' height={'auto'} />
                </div>
                <div className='m-[0_auto] text-center'>
                    <Fragment>
                        <p className='text-[20px] font-[700]'>Thank You</p>
                        <p className='text-[12px] font-[400] mt-1'>Your SIgnature/Stamp has been Received</p>
                        <p className='text-[12px] font-[400] mt-1'>You May Close the Window</p>
                    </Fragment>
                </div>
            </Modal>
        </div>
    );
};
export default ThankYouModal;